<div
  class="card mb-2 article-card"
  [ngClass]="{ 'upcoming-card': type === 'upcoming' }"
>
  <a [routerLink]="getHotelRoute(hotel)" class="text-decoration-none text-dark">
    <div class="shadow-sm rounded position-relative">
      <div class="position-relative">
        <img
          [src]="hotel.banners"
          [alt]="hotel.name"
          class="img-fluid rounded"
          style="height: 281px; object-fit: cover; width: 100%"
        />
      </div>
      <div class="text-start content-container">
        @if (type === "regular") {
          <div class="d-flex align-items-center mb-0 location-text gap-2">
            <i class="fa fa-location-dot location-icon"></i>
            {{ hotel?.cityInfo?.name }}
          </div>

          <div class="property-title" [title]="hotel.name">
            {{ hotel.name }}
          </div>
        } @else {
          <div class="d-flex align-items-center mb-0 location-text gap-2">
            <i class="fa fa-location-dot location-icon"></i>
            {{ hotel?.cityInfo?.name }}
          </div>
        }
      </div>
    </div>
  </a>
</div>
